<template>
  <div v-if="visible" class="confirm-modal-overlay" @click.self="handleCancel">
    <div class="confirm-modal">
      <div class="modal-content">
        <div class="modal-icon" v-if="icon">{{ icon }}</div>
        <div class="modal-message">{{ message }}</div>
      </div>
      <div class="modal-buttons">
        <button 
          v-if="showCancel"
          class="btn btn-cancel" 
          @click="handleCancel">
          {{ cancelText }}
        </button>
        <button 
          class="btn btn-confirm" 
          @click="handleConfirm">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: '⚠️'
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
      this.$emit('update:visible', false);
    },
    handleCancel() {
      this.$emit('cancel');
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.confirm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.confirm-modal {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 340px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-content {
  padding: 24px 20px;
  text-align: center;
}

.modal-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.modal-message {
  font-size: 16px;
  line-height: 1.6;
  color: #333;
  white-space: pre-line;
}

.modal-buttons {
  display: flex;
  border-top: 1px solid #f0f0f0;
}

.btn {
  flex: 1;
  padding: 14px 20px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  
  &:not(:last-child) {
    border-right: 1px solid #f0f0f0;
  }
  
  &:active {
    background: #f5f5f5;
  }
}

.btn-cancel {
  background: white;
  color: #666;
}

.btn-confirm {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .confirm-modal {
    width: 95%;
    max-width: none;
  }
  
  .modal-content {
    padding: 20px 16px;
  }
  
  .modal-icon {
    font-size: 40px;
  }
  
  .modal-message {
    font-size: 15px;
  }
  
  .btn {
    padding: 12px 16px;
    font-size: 15px;
  }
}
</style>
